
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
.file-input-item-holder {
  display: flex;
}
.file-input-item-holder .file-input-item-download {
  flex-shrink: 0;
  align-self: center;
  margin-right: 8px;
}
.file-input-item-holder .file-input-item-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-self: center;
  overflow: hidden;
}
.file-input-item-holder .file-input-item-wrapper .file-input-item {
  display: flex;
  font-family: var(--slh-default-font-family, "Open Sans");
  font-size: var(--slh-base-xs-font-size, 14px);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  line-height: var(--slh-base-xxs-line-height, 24px);
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
}
.file-input-item-holder .file-input-item-wrapper .file-input-item slot {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.file-input-item-holder .file-input-item-wrapper .file-input-item .icon-wrapper {
  display: flex;
  flex-shrink: 0;
  margin-right: 4px;
  fill: var(--slh-color-neutral-shade-80, #4E5E7E);
}
.file-input-item-holder .file-input-item-wrapper .file-input-item .icon-wrapper.error {
  fill: var(--slh-color-error, #FF7E70);
}
.file-input-item-holder .file-input-item-wrapper .file-input-item .icon-wrapper.completed {
  fill: var(--slh-color-success, #00B894);
}
.file-input-item-holder .file-input-item-wrapper .file-input-item .remove-icon {
  flex-shrink: 0;
  margin-left: auto;
  fill: var(--slh-color-neutral-shade-80, #4E5E7E);
  cursor: pointer;
}
.file-input-item-holder .file-input-item-wrapper .loading-bar-wrapper {
  display: flex;
  margin-top: 4px;
}

.file-input-item-error-text {
  display: flex;
  font-family: var(--slh-default-font-family, "Open Sans");
  font-size: var(--slh-base-xxs-font-size, 12px);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  line-height: var(--slh-base-xxs-line-height, 24px);
  color: var(--slh-color-error, #FF7E70);
}
`;
